import { environment } from "src/environments/environment";


export type OverlayFnObj = {
  createFieldInfoOverlayFn: Function,
  createPopupOverlayFn: Function,
  createScenarioPopupOverlayFn: Function,
  createSpreadingTypeOverlayFn: Function,
}

declare global {
    interface Window {
      initMap: ($event : any) => void;
    }
}

export class MapLoaderService {
    private static promise: Promise<any>;
    public static load(): Promise<any> {
      const map = {
        URL: 'https://maps.googleapis.com/maps/api/js?key=' + environment.googleMapsApiKey + '&libraries=drawing,geometry,places&callback=initMap',      
      }
  
      // First time 'load' is called?
      if (!this.promise) {
  
        // Make promise to load
        this.promise = new Promise(resolve => {
          this.loadScript(map.URL);        
          // Set callback for when google maps is loaded.
          window.initMap = ($event : any) => {
            resolve('google maps api loaded');
          };
        })
      }
  
      // Always return promise. When 'load' is called many times, the promise is already resolved.
      return this.promise;
    }   
  
    //this function will work cross-browser for loading scripts asynchronously
    static loadScript(src : any, callback? : any ): void {
      let s: any,
        r : any,
        t : any;
      r = false;
      s = document.createElement('script');
      s.type = 'text/javascript';
      s.src = src;
      s.onload = s.onreadystatechange = function () {
        //console.log( this.readyState ); //uncomment this line to see which ready states are called.
        if (!r && (!this.readyState || this.readyState == 'complete')) {
          r = true;
          if (typeof callback === "function")
            callback();
        }
      };
      t = document.getElementsByTagName('script')[0];
      t.parentNode!.insertBefore(s, t);
    }
    
    public static async getOverlayFnObj(): Promise<OverlayFnObj> {
      const customFieldInfoOverlay = await import('../app/map/custom-overlay-field-info');
      const customPopupOverlay = await import('../app/map/custom-overlay-popup');
      const customScenarioPopupOverlay = await import('../app/map/custom-overlay-scenario');
      const customSpreadingTypeOverlay = await import('../app/map/custom-overlay-spreading-type');
      const obj: OverlayFnObj = {
        createFieldInfoOverlayFn: customFieldInfoOverlay.createFieldInfoOverlay,
        createPopupOverlayFn: customPopupOverlay.createPopupOverlay,
        createScenarioPopupOverlayFn: customScenarioPopupOverlay.createScenarioPopupOverlay,
        createSpreadingTypeOverlayFn: customSpreadingTypeOverlay.createSpreadingTypeOverlay,
      }
      return obj;
    }
  }